import { useTranslation } from "react-i18next";
import { FormInput } from "../../../../components/FormInput";
import { Controller } from "react-hook-form";
import { classNames } from "primereact/utils";
import { Dropdown } from "primereact/dropdown";

export const AddUse =({
    register, errors, control, setValue,
})=>{
    const { t } = useTranslation();
    return(
        <form className="grid">
            <div className="col-12 lg:col-7">
                <FormInput
                    register={register}
                    errors={errors}
                    id="address"
                    name="address"
                    type="text"
                    labelText="項目名稱"
                    labelClass="required"
                />
            </div>
            <div className="col-12 lg:col-3">
                <FormInput
                    register={register}
                    errors={errors}
                    id="total"
                    name="total"
                    type="number"
                    labelText="數值"
                    labelClass="required"
                />
            </div>
            <div className="col-12 lg:col-2">
                <label htmlFor="" className="required form-label">{t('unit')}</label>
                <Controller
                    name="itemsUnit"
                    control={control}
                    // rules={{ required: { value: true, message: t('validation.required') } }}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            // appendTo={"self"}
                            optionLabel="label"
                            optionValue="value"
                            value={field.value}
                            // virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs")}
                            name="itemsUnit"
                            control={control}
                            options={[{label:'包',value:0},{label:'箱',value:1},{label:'公斤',value:2},{label:'公噸',value:3}]}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                                // setValue(`addressItems.${index}.zipcodeSeq`, "")
                            }}
                        />
                    )} />
            </div>
            <div className="col-12">
                <FormInput
                    register={register}
                    errors={errors}
                    id="remark"
                    name="remark"
                    type="text"
                    labelText={t('remark')}
                />
            </div>
        </form>
    )
}